"use strict";

exports.__esModule = true;
exports.setTranslate = setTranslate;
exports.setTranslate3D = setTranslate3D;

var _detect = require("./detect");

var use3d;

function setTranslate(el, x, y) {
  var tn = (0, _detect.getTransformName)();
  el.style[tn] = "translate(" + x + "," + y + ")";
}

function setTranslate3D(el, x, y) {
  if (use3d === undefined) use3d = (0, _detect.has3d)();
  var tn = (0, _detect.getTransformName)();

  if (use3d) {
    el.style[tn] = "translate3d(" + x + "," + y + ",0)";
  } else {
    el.style[tn] = "translate(" + x + "," + y + ")";
  }
}